import { jsx as b } from "react/jsx-runtime";
const m = "_button_gah2u_1", p = "_primary_gah2u_11", q = "_secondary_gah2u_31", v = "_action_gah2u_55", j = "_drifting_gah2u_60", w = "_shortening_gah2u_64", x = "_oval_gah2u_68", O = "_square_gah2u_71", A = "_round_gah2u_74", B = "_toggle_gah2u_77", n = {
  button: m,
  primary: p,
  default: "_default_gah2u_18",
  secondary: q,
  "secondary-new": "_secondary-new_gah2u_45",
  action: v,
  drifting: j,
  shortening: w,
  oval: x,
  square: O,
  round: A,
  toggle: B,
  "no-padding": "_no-padding_gah2u_86"
};
function N({
  borderColor: s,
  children: _,
  className: r,
  disabled: u,
  height: t,
  noPadding: e,
  onClick: g,
  regressionTag: d,
  shape: o,
  style: c,
  testId: i,
  type: l = "",
  width: a,
  ...h
}) {
  o === "square" && !t && !a && console.warn("A height and width should be provided for a square button");
  const y = {
    ...c,
    borderColor: s,
    height: t,
    width: a
  }, f = [
    n.button,
    n[l] || "",
    o ? n[o] : "",
    r || "",
    e ? n.noPadding : ""
  ].join(" ");
  return /* @__PURE__ */ b(
    "button",
    {
      className: f,
      "data-regression-tag": d,
      "data-testid": i,
      disabled: u,
      onClick: g,
      style: y,
      ...h,
      children: _
    }
  );
}
export {
  N as default
};
